import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core'

@Component({
  selector: 'add-date-btn',
  templateUrl: './add-date-btn.component.html',
  styleUrls: ['./add-date-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddDateBtnComponent {
  @Input() text: string
  @Output() onClick = new EventEmitter<void>()

  addDateBefore($event: MouseEvent) {
    $event.preventDefault()
    $event.stopPropagation()
    this.onClick.emit()
  }
}
